import MouseFollower from "mouse-follower";
import gsap from "gsap";

export default function initCursor() {
  MouseFollower.registerGSAP(gsap);
  const footer = document.querySelector('.footer');
  const isDesktop = window.matchMedia('(min-width: 1024px)');
   const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (isTouchDevice) return;
  const cursor = new MouseFollower({
    speed: 0.45,
    ease: "power3.out",
    skewing: 0,
    iconSvgSrc: "/wp-content/themes/geometric/build/images/next.svg",
    iconSvgClassName: "",
    iconSvgNamePrefix: "-",
    skewingText: 1.5,
    skewingIcon: 2.5,
    skewingMedia: 1.5,
    skewingDelta: 0.001,
    skewingDeltaMax: 0.08,
    stickDelta: 0.2,
    showTimeout: 20,
    hideOnLeave: true,
    hideTimeout: 600,
    hideMediaTimeout: 600,
    stateDetection: {
      "-pointer": "a,button",
      "-hidden": "iframe",
    },
  });

  document.querySelectorAll(".pink-gradient, .hero-home, .hero").forEach(section => {
  let ball;
  let moveX, moveY;
  let active = false;
  let visible = false;
  let lastMouse = { x: 0, y: 0 };

  const observer = new IntersectionObserver(
    ([entry]) => {
      active = entry.isIntersecting;
      if (!active) hideBall();
    },
    { threshold: 0.1 }
  );

  observer.observe(section);

  function createBall() {
    if (ball) return;

    ball = document.createElement("div");
    ball.className = "blur-ball";
    section.appendChild(ball);

    const rect = section.getBoundingClientRect();
    const half = ball.offsetWidth / 2;

    const clampX = x => Math.min(rect.width - half, Math.max(half, x));
    const clampY = y => Math.min(rect.height - half, Math.max(half, y));

    moveX = gsap.quickTo(ball, "x", { duration: 1, ease: "power3.out" });
    moveY = gsap.quickTo(ball, "y", { duration: 1, ease: "power3.out" });

    ball._clampX = clampX;
    ball._clampY = clampY;

    gsap.set(ball, { opacity: 0 });
  }

  function showBall() {
    if (!ball || visible) return;
    visible = true;

    gsap.to(ball, {
      opacity: 1,
      duration: 0.4,
      ease: "power2.out"
    });
  }

  function hideBall() {
    if (!ball || !visible) return;
    visible = false;

    gsap.to(ball, {
      opacity: 0,
      duration: 0.4,
      ease: "power2.out"
    });
  }

  window.addEventListener("mousemove", e => {
    lastMouse.x = e.clientX;
    lastMouse.y = e.clientY;
    if (!isDesktop.matches || !active) return;
    const rect = section.getBoundingClientRect();
    const x = lastMouse.x - rect.left;
    const y = lastMouse.y - rect.top;

    const isInside =
      x >= 0 && y >= 0 &&
      x <= rect.width && y <= rect.height;

    if (!isInside) {
      hideBall();
      return;
    }

    createBall();
    showBall();

    moveX(ball._clampX(x));
    moveY(ball._clampY(y));
  });
  window.addEventListener("scroll", () => {
    if (!ball || !active) return;

    const rect = section.getBoundingClientRect();
    const x = lastMouse.x - rect.left;
    const y = lastMouse.y - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      hideBall();
    }
  });
});


  //  section.addEventListener("mouseenter", (e) => {
  //   console.log('mouseenter')
  //   if(!isDesktop.matches) return;
  //   if (!ball) createBall(e);
  // });

  // section.addEventListener("mousemove", (e) => {
  //   if(!isDesktop.matches) return;
  //   if (!ball) createBall(e);

  //   const rect = section.getBoundingClientRect();
  //   const x = e.clientX - rect.left;
  //   const y = e.clientY - rect.top;

  //   moveX(ball._clampX(x));
  //   moveY(ball._clampY(y));
  // });

  // section.addEventListener("mouseleave", () => {
  //   console.log('mouse leave')
  //   if (!isDesktop || !ball) return;

  //     // gsap.to(ball, {
  //     //   opacity: 0,
  //     //   duration: 0.3,
  //     //   ease: "power2.out",
  //     //   onComplete: () => {
  //     //     if(ball) {
  //     //       ball.remove();
  //     //     }
  //     //     ball = null;
  //     //     moveX = null;
  //     //     moveY = null;
  //     //   }
  //     // });
  //   });
  // window.addEventListener("mousemove", e => {
  //   if (!isDesktop.matches || !active) return;
    
  //   const rect = section.getBoundingClientRect();
  //   const x = e.clientX - rect.left;
  //   const y = e.clientY - rect.top;
    
  //   if (
  //     x < 0 || y < 0 ||
  //     x > rect.width || y > rect.height
  //   ) return;
    
  //   if (!ball) createBall(e);
    
  //   moveX(ball._clampX(x));
  //   moveY(ball._clampY(y));
  // });
  // });
  
  document.querySelectorAll('[data-cursor-text]').forEach(item=> {
    const text = item.dataset.cursorText;
    item.addEventListener('mouseenter', () => {
      if(!isDesktop.matches) return;
      cursor.setText(text);
    });
    item.addEventListener('mouseleave', () => {
      if(!isDesktop.matches) return;
      cursor.removeText();
    });
  });

  footer.addEventListener('mouseenter', () => {
    if(!isDesktop.matches) return;
    cursor.addState('-inverse'); // you can pass multiple states separated by whitespace
    
  });
  
  footer.addEventListener('mouseleave', () => {
    if(!isDesktop.matches) return;
    cursor.removeState('-inverse');
  });

}